import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a32cec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queryResults" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "recommend" }
const _hoisted_4 = { class: "history" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "历史搜索", -1))
const _hoisted_6 = { class: "list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "history" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "热门搜索", -1))
const _hoisted_10 = { class: "list" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createBlock(_component_VanPopup, {
    class: "SearchCategorie",
    show: $setup.props.modelValue,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.props.modelValue) = $event)),
    style: {"height":"100vh","width":"100vw","z-index":"10000"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VanSearch, {
        modelValue: $setup.getListData.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.getListData.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "搜索品种",
        round: "",
        "show-action": ""
      }, {
        action: _withCtx(() => [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {$setup.emit("cancel");$setup.emit("update:modelValue",false)})
          }, "取消")
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_component_VanList, {
          class: "queryResultsWarpper",
          loading: $setup.loading,
          "immediate-check": false,
          finished: $setup.finished,
          onLoad: $setup.page
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "queryResultsItem",
                key: `queryResultsItem${idx}`,
                onClick: ($event: any) => ($setup.selected(item))
              }, _toDisplayString(item.path), 9, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ], 512), [
        [_vShow, $setup.categories.length != 0 && $setup.getListData.name != ""]
      ]),
      _withDirectives(_createElementVNode("div", { class: "noData" }, "没有找到“" + _toDisplayString($setup.getListData.name) + "”品种", 513), [
        [_vShow, $setup.categories.length == 0 && $setup.getListData.name != "" && !$setup.loading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.history, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx,
                onClick: ($event: any) => ($setup.selected(item))
              }, _toDisplayString(item.name), 9, _hoisted_7))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotList, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx,
                onClick: ($event: any) => ($setup.selected(item))
              }, _toDisplayString(item.name), 9, _hoisted_11))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, $setup.categories.length == 0 || $setup.getListData.name == ""]
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}